import React from 'react';
import { is } from 'ramda';

import { connect } from 'react-redux';

import { isLoggedIn } from '../reducers/currentUserReducer';

const filterFn = () => false;

const LoggedIn = ({ children, loggedIn = false, testFn=filterFn }) => {
    const childrenArray = is(Array, children) ? children : [children];
    const [
        WhenLoggedIn = null,
        WhenLoggedOut = null,
    ] = childrenArray;

    return loggedIn || testFn() ? WhenLoggedIn : WhenLoggedOut;
};

const mapState = (state) => {
    return {
        loggedIn: isLoggedIn(state),
    };
};

export default connect(mapState)(LoggedIn);
